import { render } from "./ChatEditorCmp.vue?vue&type=template&id=1225528b"
import script from "./ChatEditorCmp.vue?vue&type=script&lang=js"
export * from "./ChatEditorCmp.vue?vue&type=script&lang=js"

import "./ChatEditorCmp.vue?vue&type=style&index=0&id=1225528b&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__